<template>
  <div>

    <b-modal id="modalTraceableMultiplePQsComponent" size="lg" :title="`Marcar producto en ${getAction ? 'uso' : 'desuso'}`" scrollable centered
      no-close-on-backdrop no-close-on-esc no-enforce-focus no-fade header-close-content="">

      <!-- Opciones -->
      <b-form-group>
        <label for="productsAction">Productos a procesar</label>
        <br />
        <el-select id="productsAction" name="productsAction" v-model="productsAction">
          <el-option v-for="item in actionsInProducts" :key="item.id" :label="item.text"
            :value="item.id" />
        </el-select>
      </b-form-group>

      <!-- Selección específica de productos -->
      <b-form-group v-if="productsAction == 3">
        <filterProductsFilledComponent
          :onRemoteMethod="onHandleChangeProducts"
          :onSelected="onHandleSelectedProductsFilled"
          :onTrashSelected="onHandleTrashSelectedProduct"
          :itemsSelecteds="selectedProductsFilled"
          messageInfo="No hay productos seleccionados."
        />
      </b-form-group>

      <!-- Motivo por el cual realiza la acción -->
      <b-form-group>
        <label for="traceableText">Motivo por el cual realiza la acción</label>
        <b-form-textarea id="traceableText" v-model="traceableText" placeholder="..." rows="4"
          max-rows="6" maxLength="255" minLength="1"></b-form-textarea>
        <div class="d-flex justify-content-end">
          <span class="text-xs small text-gray">{{ traceableText.length }} de 255 caracteres</span>
        </div>
      </b-form-group>

      <!-- Footer -->
      <template #modal-footer>

        <b-button variant="primary" @click="onHandleOk()"
          :disabled="isDisabledBtnOk">
          Guardar
        </b-button>

        <b-button variant="light" @click="onHandleCancel()">
          Cancelar
        </b-button>

      </template>

    </b-modal>

  </div>
</template>

<script>

// Generales
import { mapActions } from 'vuex';

// Componentes
import Swal from 'sweetalert2';
import filterProductsFilledComponent from '../../FilterProductsFilled.vue'

export default {
  name: 'ModalTraceableMultiplePQsComponent',
  props: {
    actionOK: {
      type: Function,
      default: () => { },
      require: false
    },
    actionCancel: {
      type: Function,
      default: () => { },
      require: false
    },
    payload: {
      type: Object | null,
      default: {},
      require: false
    },
  },
  components: {
    filterProductsFilledComponent
  },
  data: function () {
    return {
      traceableText: '',
      actionsInProducts: [
        {id: 1, text: 'Productos de la página actual'},
        {id: 2, text: 'Todos los productos'},
        {id: 3, text: 'Seleccionar productos específicos'},
      ],
      productsAction: 1,
      selectedProductsFilled: []
    };
  },
  computed: {
    getAction() {
      return (this.payload && typeof this.payload === 'object' && 'action' in this.payload) ? this.payload.action : true
    },
    getProductsId() {
      return this.selectedProductsFilled.map(x => x.id);
    },
    isDisabledBtnOk() {
      if (this.traceableText.length == 0 || this.traceableText.length > 255) return true;
      
      if ((!this.getProductsId || this.getProductsId.length <= 0) && this.productsAction == 3) return true;

      return false;
    }
  },
  methods: {
    ...mapActions('productsSearch', [
      'filterProductsFilledInByName'
    ]),
    onHandleOk() {
      Swal.fire({
        title: "Trazabilidad de productos",
        text: "¿Está seguro de que desea realizar esta acción?",
        icon: 'info',
        confirmButtonColor: '#32696e',
        showCancelButton: true,
        confirmButtonText: '!Si, estoy seguro!',
        cancelButtonText: 'No, cancelar',
      }).then(async (responseHandle) => {
        if (responseHandle.isConfirmed) {
          await this.actionOK({ 
            ...this.payload, 
            comments: this.traceableText, 
            productsAction: this.productsAction,
            selectedProductsFilled: this.getProductsId
          })
        }
      });
    },
    onHandleCancel() {
      this.actionCancel();
      this.traceableText = "";
      this.selectedProductsFilled = []
    },
    /**
     * Controlar cambios en el select de buscar productos.
     *
     * @author Fernando Claros
     */
    async onHandleChangeProducts(value) {

      await this.filterProductsFilledInByName({
        company_id: this.$route.params.id,
        product_param: value
      });

    },
    /**
    * Seleccionar y agregar el producto a la lista.
    *
    * @author Fernando Claros
    */
    onHandleSelectedProductsFilled(lists) {
      this.selectedProductsFilled = lists
    },
    /**
    * Eliminar el producto de la lista.
    *
    * @param {Array} lists
    * @author Fernando Claros
    */
    onHandleTrashSelectedProduct(lists) {
      this.selectedProductsFilled = lists
    },
  }
};
</script>